
export function momentPickerConfig(momentPickerProvider) {
    'ngInject';

    const assetsPath = process.env.assetsPath;

    momentPickerProvider.options({
        'leftArrow': '<img src="' + assetsPath + 'icons/meltwater-icons/navigation-back.svg" />',
        'rightArrow': '<img src="' + assetsPath + 'icons/meltwater-icons/navigation-forward.svg" />',
/*
        * 'locale': 'en', // Locale code, supported locales from https://github.com/moment/moment/tree/develop/locale
        * 'format': 'L LTS', // Format of the output value and min/max date
        * 'min-view': 'decade', // Minimum navigable view, supported values decade,year,month,day,hour,minute
        * 'max-view': 'minute', // Maximum navigable view, supported values decade,year,month,day,hour,minute
        'start-view': 'year', // Initial view, supported values decade,year,month,day,hour,minute
        'position': '', // Sets fixed position for the picker, supported values 'top left', 'top right', 'bottom left', 'bottom right'
        'inline': false, // Views the picker inline
        * 'validate': true, // Forces picker value between the range minDate and maxDate
        'autoclose': true, // Closes the picker after selecting a date
        'set-on-select': false, // Updates picker model after selecting a date in each view
        'today': false, // Highlights current day
        'keyboard': false, // Allows using the keyboard to navigate the picker
        'show-header': true, // Shows the header in the view
        'left-arrow': '&larr;', // Left arrow string (HTML allowed)
        'right-arrow': '&rarr;', // Right arrow string (HTML allowed)
        'additions': { top: undefined, bottom: undefined }, // Template URL for custom contents above and below each picker view (inside dialog)

        'years-format': 'YYYY', // Years format in decade view
        'months-format': 'MMM', // Months format in year view
        'days-format': 'D', // Days format in month view

        'hours-format': 'HH:[00]', // Hours format in day view
        'hours-start': 0, // First rendered hour in day view (24h format)
        'hours-end': 23, // Last rendered hour in day view (24h format)

        'minutes-format': 2, // Minutes format in hour view
        'minutes-step': 5, // Step between each visible minute in hour view
        'minutes-start': 0, // First rendered minute in hour view
        'minutes-end': 59, // Last rendered minute in hour view

        'seconds-format': 'ss', // Seconds format in minute view
        'seconds-step': 1, // Step between each visible second in minute view
        'seconds-start': 0, // First rendered second in minute view
        'seconds-end': 59, // Last rendered second in minute view


        // The following are additioanl props supported on moment picker instance
        * 'moment-picker': '', // Two-way bindable property as formatted datetime string.
        'ng-model': '', // Two-way bindable property as Moment.js object.
        * 'min-date': '', // Two-way bindable property representing the minimum selectable date (as String in the same format of the value, or as a Moment.js object).
        * 'max-date': '', // Two-way bindable property representing the maximum selectable date (as String in the same format of the value, or as a Moment.js object).
        'start-date': '', // Two-way bindable property representing the initial date to be shown in picker (as String in the same format of the value, or as a Moment.js object).
        'disable': false, // Disables the picker if truly.
        'is-open': '', // Open/closes the picker when set to true or false.
*/
    });
}



// WEBPACK FOOTER //
// ./src/lib/components/date-picker/date-picker.config.ts